import {
  RouteGetStores_storeId_,
  type ResponseGetStores_storeId_,
} from "@CommonApi/stores/_storeId_";
import { useQuery } from "@tanstack/react-query";
import { API, getRequest } from "src/utils/axios";

const storeQueryKey = (storeId: number) => ["stores", storeId] as const;

export const fetchStore = async (
  storeId: number,
  signal?: AbortSignal,
): Promise<ResponseGetStores_storeId_> => {
  const { data } = await getRequest<ResponseGetStores_storeId_>(
    `${API}${RouteGetStores_storeId_}`,
    { params: { storeId }, signal },
  );
  return data;
};

export const useStoreQuery = (storeId: number) =>
  useQuery({
    queryKey: storeQueryKey(storeId),
    queryFn: ({ signal }) => fetchStore(storeId, signal),
    enabled: Number.isInteger(storeId) && storeId > 0,
  });
